import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

export default function SensorCard({ title, value, unit, icon, color }) {
    return (
        <Card>
            <CardContent>
                <Box display="flex" alignItems="center" mb={1}>
                    {icon && <Box sx={{ mr: 1, color }}>{icon}</Box>}
                    <Typography variant="subtitle2" color="textSecondary">{title}</Typography>
                </Box>
                <Typography variant="h4" sx={{ color }}>
                    {value}{unit}
                </Typography>
            </CardContent>
        </Card>
    );
}
